import React, { useEffect, useMemo } from 'react';

import { debounce } from '@mui/material';
import { Box } from '@mui/system';
import { useFormik } from 'formik';

import { getPharmaciesForPharmacyAdmin } from '@pharmaplan/common';

import { useAppDispatch } from '../../../../../../hooks/useAppDispatch';
import CustomTextField from '../../../../../common/CustomTextField';
import strings from '../../../../../../localization';
import styles from '../../styles';

const SEARCH_DEBOUNCE_MS = 300;

const AssignAccountsSearch = () => {
  const dispatch = useAppDispatch();

  const formik = useFormik({
    initialValues: {
      search: '',
    },
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onSubmit: () => {},
  });

  const { search } = formik.values;

  const debouncedSearchPharmacies = useMemo(
    () =>
      debounce((input: string) => {
        dispatch(getPharmaciesForPharmacyAdmin({ page: 0, userText: input }));
      }, SEARCH_DEBOUNCE_MS),
    [dispatch],
  );

  useEffect(() => {
    debouncedSearchPharmacies(search);
  }, [debouncedSearchPharmacies, search]);

  return (
    <Box sx={styles.searchContainer}>
      <CustomTextField
        name="search"
        customClass={styles.borderRadiusRemove}
        formik={formik}
        id="search"
        errorContainer={false}
        placeholder={strings.search}
      />
    </Box>
  );
};

export default AssignAccountsSearch;
